const svgList = {
  'ar': {
    name: 'Argentina',
    code: 'AR',
    file: require('../../images/flags/ar.pictogram.svg'),
  },
  'br': {
    name: 'Brazil',
    code: 'BR',
    file: require('../../images/flags/br.pictogram.svg'),
  },
  'ca': {
    name: 'Canada',
    code: 'CA',
    file: require('../../images/flags/ca.pictogram.svg'),
  },
  'cl': {
    name: 'Chile',
    code: 'CL',
    file: require('../../images/flags/cl.pictogram.svg'),
  },
  'cn': {
    name: 'China',
    code: 'CN',
    file: require('../../images/flags/cn.pictogram.svg'),
  },
  'co': {
    name: 'Colombia',
    code: 'CO',
    file: require('../../images/flags/co.pictogram.svg'),
  },
  'cr': {
    name: 'Costa Rica',
    code: 'CR',
    file: require('../../images/flags/cr.pictogram.svg'),
  },
  'do': {
    name: 'Dominican Republic',
    code: 'DO',
    file: require('../../images/flags/do.pictogram.svg'),
  },
  'ec': {
    name: 'Ecuador',
    code: 'EC',
    file: require('../../images/flags/ec.pictogram.svg'),
  },
  'eu': {
    name: 'Europe',
    code: 'EU',
    file: require('../../images/flags/eu.pictogram.svg'),
  },
  'sv': {
    name: 'El Salvador',
    code: 'SV',
    file: require('../../images/flags/sv.pictogram.svg'),
  },
  'fr': {
    name: 'France',
    code: 'FR',
    file: require('../../images/flags/fr.pictogram.svg'),
  },
  'gt': {
    name: 'Guatemala',
    code: 'GT',
    file: require('../../images/flags/gt.pictogram.svg'),
  },
  'hn': {
    name: 'Honduras',
    code: 'HN',
    file: require('../../images/flags/hn.pictogram.svg'),
  },
  'it': {
    name: 'Italia',
    code: 'IT',
    file: require('../../images/flags/it.pictogram.svg'),
  },
  'jp': {
    name: 'Japan',
    code: 'JP',
    file: require('../../images/flags/jp.pictogram.svg'),
  },
  'mx': {
    name: 'Mexico',
    code: 'MX',
    file: require('../../images/flags/mx.pictogram.svg'),
  },
  'nl': {
    name: 'Netherlands',
    code: 'NL',
    file: require('../../images/flags/nl.pictogram.svg'),
  },
  'ni': {
    name: 'Nicaragua',
    code: 'NI',
    file: require('../../images/flags/ni.pictogram.svg'),
  },
  'pa': {
    name: 'Panama',
    code: 'PA',
    file: require('../../images/flags/pa.pictogram.svg'),
  },
  'pe': {
    name: 'Peru',
    code: 'PE',
    file: require('../../images/flags/pe.pictogram.svg'),
  },
  'es': {
    name: 'Spain',
    code: 'ES',
    file: require('../../images/flags/es.pictogram.svg'),
  },
  'gb': {
    name: 'United Kingdom',
    code: 'GB',
    file: require('../../images/flags/gb.pictogram.svg'),
  },
  'us': {
    name: 'United States',
    code: 'US',
    file: require('../../images/flags/us.pictogram.svg'),
  },
  'kr': {
    name: 'Korea',
    code: 'KR',
    file: require('../../images/flags/kr.pictogram.svg'),
  },
  've': {
    name: 'Venezuela, Bolivarian Republic of',
    code: 'VE',
    file: require('../../images/flags/ve.pictogram.svg'),
  },
};

export default svgList;
